import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoggedInGuard } from './core/guards/logged-in.guard';

const routes: Routes = [


  /*{ path: '', loadChildren: () => import('./landing/landing.module').then(m => m.LandingPageModule), pathMatch: 'full' },*/

    /*{
    path: '',
    loadChildren: () => import('./gourmet-slovenia/gourmet-slovenia.module').then( m => m.GourmetSloveniaPageModule)
    },*/

  /*{ path: 'shambala', redirectTo: 'restavracija/331/restavracija-shambala' },
  { path: 'ruj', redirectTo: 'restavracija/332/gostilnica-ruj' },
  { path: 'putr', redirectTo: 'restavracija/333/restavracija-putr' },
  { path: 'bistro-storja', redirectTo: 'restavracija/334/bistro-storja' },
  { path: 'storja', redirectTo: 'restavracija/334/bistro-storja' },
  { path: 'rozmarin', redirectTo: 'restavracija/335/restavracija-rozmarin' },
  { path: 'steakhouse', redirectTo: 'restavracija/335/rozmarin' },
  { path: 'restavracija/335/steakhouse-rozmarin', redirectTo: 'restavracija/335/rozmarin' },
  { path: 'grajski-vrt', redirectTo: 'restavracija/370/grajski-vrt' },
  { path: 'pen', redirectTo: 'restavracija/347/pen-klub-restavracija' },
  { path: 'cool-house', redirectTo: 'restavracija/389/restavracija-cool-house' },
  { path: 'city-terasa', redirectTo: 'restavracija/390/city-terasa-maribor' },
  { path: 'strelec', redirectTo: 'restavracija/344/restavracija-strelec' },
  { path: 'dine', redirectTo: 'restavracija/394/dine-experience' },
  { path: 'dine-experience', redirectTo: 'restavracija/394/dine-experience' },
  { path: 'zeleni-kras', redirectTo: 'restavracija/435/zeleni-kras' },
  { path: 'koline', redirectTo: 'restavracija/435/zeleni-kras' },
  { path: 'gjerkes', redirectTo: 'restavracija/391/gjerkes-estate-of-taste' },
  { path: 'boccaccio', redirectTo: 'restavracija/395/boccaccio-sentjakob' },
  { path: 'pec', redirectTo: 'restavracija/413/gostilna-pec' },
  { path: 'me', redirectTo: 'restavracija/392/jaz-by-me' },
  { path: 'most', redirectTo: 'restavracija/415/restavracija-most' },
  { path: 'wonderland', redirectTo: 'restavracija/437/wonderland' },
  { path: 'blejski-grad', redirectTo: 'restavracija/436/restavracija-blejski-grad' },
  { path: 'blejskigrad', redirectTo: 'restavracija/436/restavracija-blejski-grad' },*/

  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },

  { path: 'moj-profil', canActivate: [ LoggedInGuard ], loadChildren: () => import('./my-profile/my-profile.module').then(m => m.MyProfilePageModule) },

  { path: ':activity', loadChildren: () => import('./shop-detail/shop-detail.module').then(m => m.ShopDetailPageModule) },

  {  
    path: 'info',
    loadChildren: () => import('./info/info.module').then( m => m.InfoPageModule)
  },
  {
    path: 'oceni',
    loadChildren: () => import('./rating/rating.module').then( m => m.RatingPageModule)
  },
  

  //shop-listing routes
  //{ path: ':location/:serviceType/:service', loadChildren: () => import('./shop-listing/shop-listing.module').then(m => m.ShopListingPageModule) },
  //{ path: ':location/:serviceType', loadChildren: () => import('./shop-listing/shop-listing.module').then(m => m.ShopListingPageModule) },
  //{ path: ':location', loadChildren: () => import('./shop-listing/shop-listing.module').then(m => m.ShopListingPageModule) },

  //not found routes redirect to landing page

  /*{
    path: 'gourmet-slovenia',
    loadChildren: () => import('./gourmet-slovenia/gourmet-slovenia.module').then( m => m.GourmetSloveniaPageModule)
  },*/
  
  { path: '**', redirectTo: 'brivska-sola' },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled', enableTracing: false , preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }